import { handleRedirectionWithSignupSource } from '@common/utils'
import Button from '@components/atoms/button'
import Modal from '@components/common/modal'
import { Trans } from '@lingui/macro'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { ChevronRight } from 'react-feather'

const SUBJECTS = [
  { label: 'AI & Coding', query: '?course=coding' },
  { label: 'Math', query: '?course=math-trial-class' },
  {
    label: 'Public Speaking & Communication',
    query: '?course=public-speaking-trial-class',
  },
  {
    label: 'Creative Writing & Storytelling',
    query: '?course=creative-writing-storytelling-trial-class',
  },
]

const PersonalizedTrialStrip = () => {
  const router = useRouter()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <section className="bg-orange-600 text-white">
      <div className="container mx-auto px-5 py-12 flex flex-col md:flex-row items-center text-center md:text-left gap-5">
        <div className="flex-1">
          <h2 className="text-xl lg:text-2xl font-600">
            <Trans>Not sure which course is right for your child?</Trans>
          </h2>
          <p className="mt-1">
            <Trans>
              Let us help you find the best fit with a free personalized trial.
            </Trans>
          </p>
        </div>
        <Button
          variant="outline"
          intent="primary"
          size="lg"
          className="w-full md:w-auto leading-tight py-3 bg-white border-white shadow-md"
          // Size presets fix the height, which clips the label when it wraps on
          // narrow phones
          style={{ height: 'auto' }}
          onClick={() => setIsModalOpen(true)}
        >
          <Trans>Book a free personalized lesson</Trans>
        </Button>

        <Modal
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          isCrossIconShown
          closeOnOutsideClick
          animated
          // Modal top-aligns on mobile so tall dialogs don't crop; this one is
          // short, and my-auto centers it without that risk
          containerClassName="my-auto"
        >
          <div className="text-grey">
            <h3 className="text-xl font-600 mb-5 pr-6">
              <Trans>What would you like your child to learn?</Trans>
            </h3>
            <div className="space-y-3">
              {SUBJECTS.map(({ label, query }) => (
                <button
                  key={label}
                  type="button"
                  onClick={() =>
                    handleRedirectionWithSignupSource(
                      router.asPath,
                      `/register/${query}`
                    )
                  }
                  className="focus:outline-none w-full flex items-center justify-between space-x-3 text-left border border-grey-300 rounded-lg px-5 py-4 font-600 text-base md:text-lg hover:border-orange hover:text-orange"
                >
                  <span>{label}</span>
                  <ChevronRight size={20} className="flex-shrink-0" />
                </button>
              ))}
            </div>
          </div>
        </Modal>
      </div>
    </section>
  )
}

export default PersonalizedTrialStrip
